export function formatPhoneNumber(value) {
  if (value) {
    return value.replace(/\D/g, '').replace(/^(\d{2})(\d)/g, '($1) $2').replace(/(\d)(\d{4})$/, '$1-$2');
  }

  return value;
};

export function formatCpf(value) {
  if (value) {
    return value.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  return value;
};

export function formatMoney(value) {
  if (value) {
    return value.replace(/\D/g, '').replace(/(\d{0,15})(\d{2})/, 'R$ $1,$2');
  }

  return value;
};

export function formatCep(value) {
  if (value) {
    return value.replace(/\D/g, '').replace(/(\d{5})(\d{1,3})/, '$1-$2');
  }

  return value;
};
